import * as React from 'react';
import { connect } from 'react-redux';
import { Accordion, Card } from 'react-bootstrap';
import VAPSTile from '../../PersonalInsurance/VAPSTile';
import './PolicyDetails.css';
import { useSelector, useDispatch } from 'react-redux'
import { useState } from 'react';
import { DASHBOARD, PERSONAL_INSURANCE, DOWNLOAD_THE_APP, SEE_AVAILABLE_AREAS } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showComingSoon } from '../../../actions/modalActions';
import { Image } from 'react-bootstrap';
import FAQItem from '../../FAQ/FAQItem';

const PolicyDetailsCodered = () => {

    const [isInEdit, updateEditing] = useState(false);
    const [accordionFAQActiveKey, setAccordionFAQActiveKey] = useState(-1);
    const [accordionPolicyActiveKey, setAccordionPolicyActiveKey] = useState(-1);

    let availableAreas = SEE_AVAILABLE_AREAS;

    let faqSet = [{
        header: "Which response partner does King Price use",
        body: "<p class='mb-0'>We’ve partnered with Secura, a PSIRA-registered (Private Security Industry Regulatory Authority) armed response network.</p>",
        id: 1
    },
    {
        header: "When will I have access to code red",
        body: "<p class='mb-0'>You’ll have access to code red once you’ve downloaded our app, registered for code red, accepted our T’s & C’s and paid your first monthly or pro rata premium.</p>",
        id: 2
    },
    {
        header: "Can my family use code red",
        body: "<p class='mb-0'>Unfortunately not… For now, only the policyholder is covered, but we’re working on extending this cover to members of your household.</p>",
        id: 3
    },
    {
        header: "How many times a year can I use this feature",
        body: "<p class='mb-0'>You can activate code red as many times as you need to, provided that you don’t abuse the service.</p>",
        id: 4
    },
    {
        header: "Can I use code red when I’m in another country",
        body: `<p>Nope, code red is only available in South Africa. You’re covered in all major metros and sub-metros and many outlying areas. It’s your responsibility to familiarise yourself with these areas, and you can do so by clicking <a class="codeRedLink" href='${availableAreas}' target='_blank'>here</a>.</p>
                <p class="mb-0">If you’re outside the scope of our response network (in SA) we’ll let your local police know so that they can help you.</p>`,
        id: 5
    },
    {
        header: "How will my location be used",
        body: "<p class='mb-0'>We’ll only use your location for lawful and valid reasons, to provide code red services to you. We also store this info in a secure storage database, so your location is completely safe with us.</p>",
        id: 6
    },
    {
        header: "Does King Price cover all emergency responders’ costs",
        body: "<p class='mb-0'>You’re not covered for any costs charged by any emergency service that’s dispatched as a result of you activating code red.</p>",
        id: 7
    },
    {
        header: "Can I use free SMSs to activate code red",
        body: "<p class='mb-0'>You must have data on your phone, and this is for your account. Your service provider’s standard data rates will apply.</p>",
        id: 8
    },
    {
        header: "Our T’s and C’s",
        body: "<ul>" +
            "<li>Click <a className='codeRedLink' target='_blank' href='https://www.kingprice.co.za/terms-and-conditions/'>here</a> for the full code red T’s and C’s.</li>" +
            "<li class='mt-15px'>Code red aims to provide support, if possible, in circumstances where you feel physically threatened. It isn’t intended to reduce any physical threat to you and shouldn’t be viewed as a preventative measure.</li>" +
            "<li class='mt-15px'>Response times, or access to and availability of responding vehicles and services aren’t guaranteed.</li>" +
            "<li class='mt-15px'>You agree that we can collect, store and analyse data arising from your use of code red. Location data from your cellphone will be gathered and securely transmitted to our data storage facility, where it’ll be securely stored. This data will be used for lawful and valid reasons, primarily to provide code red services to you.</li>" +
            "<li class='mt-15px'>Our code red partner and the entity providing the code red service is a company called Secura, a representative of a network of hundreds of armed response companies who are all registered with PSIRA (the Private Security Industry Regulatory Authority).</li>" +
            "</ul>",
        id: 9
    },
    ];
    
    const dispatch = useDispatch();

    function editPolicyInfo() {
        dispatch(showComingSoon());
    }

    function cancelEdit() {
        updateEditing(false);
    }

    function saveEdit() {
        updateEditing(false);
    }

    const cover = useSelector(state => state.profile.selectedPersonalCover)

    const profileState = useSelector(state => state.profile);
    const isMobile = window.innerWidth <= 975;
    let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }]
    let downloadApp = DOWNLOAD_THE_APP;

    let faq;
    if (faqSet) {
        faq = faqSet.map((item) => {
            if (item.header !== "") {
                return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={accordionFAQActiveKey} />
            }
        });
    }

    let coverStartDate = (cover.riskItems[0].coverStartDate?.toString().trim().length > 0) ? cover.riskItems[0].coverStartDate : "";

    return (
        <>
            {isMobile &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Code red" />
            }
            <div className="box mb-3">
                {/*Policy Details - Desktop layout*/}
                <div className="d-lg-block d-none policyDetailsCodeRed" id="PolicyDetails">
                    <div className="pl-3 pr-3 pt-3 code-red-holder">
                        <div id="firstDiv" className="row border-bottom pb-3">
                            <div className="col-8">
                                <h2 className="carName mb-0">{cover.riskItems[0].description}</h2>
                                <p className="Personal-safety-assi">Personal safety assistance</p>
                                <p className="mb-0">Monthly premium</p>
                                <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                {coverStartDate.length > 0 &&
                                    <div>
                                        <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                        <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                    </div>
                                }
                            </div>
                            <div className="col-4 text-right pl-0">
                                {!isInEdit &&
                                    <button className="btn btn-outline-red mb-3 mt-3 mr-1" onClick={editPolicyInfo} id="EditPolicy">Update policy</button>
                                }
                                {isInEdit &&
                                    <div className="mt-3 mb-3">
                                        <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                        <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                    </div>
                                }
                            </div>
                        </div>

                        {/*Benefits*/}
                        <div id="BenefitsDiv" className="mt-3 mb-3">
                            <p className="Benefits">Benefits</p>
                            <div className="row">
                                <div className="col-lg-4 col-12 pr-0 new-benefits-col">
                                    <div className="icon-checkmark-circle new-benefits-col"></div> <span className="BenefitsItems">24/7 assistance</span>
                                </div>
                                <div className="col-lg-4 col-12 p-0 new-benefits-col">
                                    <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">Instant response</span>
                                </div>
                                <div className="col-lg-4 col-12 p-0 new-benefits-col">
                                    <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">Cover in all major/sub-metros</span>
                                </div>
                            </div>
                        </div>

                        {/*Test code red*/}
                        <div className="row border-top"></div>
                        <div id="TestCodered" className="mt-lg-4 mb-15px">
                            <p className="Benefits">Test code red</p>
                            <div className="row py-2">
                                <div className="col-lg-8 col-md-6 col-12 col-12">
                                    <p>Please take a minute to test code red on your mobile device (phone or tablet) with the King Price app.</p>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12 text-lg-right">
                                    <a className="btn btn-solid-aqua" id="buttonAqua" href={downloadApp} target="_blank">Download the app</a>
                                </div>
                            </div>
                        </div>

                        {/*Where am I covered*/}
                        <div className="row border-top"></div>
                        <div id="Accessories" className="mt-lg-4">
                            <p className="Benefits">Where am I covered</p>
                            <div className="row py-2">
                                <div className="col-lg-8 col-12">
                                    <p>You’re covered in all major metros and sub-metros and many outlying areas. For more info on our response network click on the ‘see available areas’ button:</p>
                                </div>
                                <div className="col-lg-4 col-12 text-lg-right">
                                    <a className="btn btn-outline-red mb-3 mt-3 mr-1" href={availableAreas} target="_blank" id="areas">See available areas</a>
                                </div>
                            </div>
                        </div>

                        {/*Policy holder details*/}
                        <hr className="policy-details-hr mt-8px mb-20px" />
                        <div className="col-12 nopa">
                            <div id="DetailsDiv" className="new-ssp-faq-block">
                                <Accordion onSelect={(e) => setAccordionPolicyActiveKey(Number(e))}>
                                    <Card className=" mb-lg-3">
                                        <Accordion.Toggle as={Card.Header} eventKey="1">
                                            <div className="row align-items-center">
                                                <div className="col policyHolderDetails">
                                                    Policyholder details
                                                </div>
                                                <div className={"accordion-arrow-svg" + ((accordionPolicyActiveKey === 1) ? ' isRotatednew' : '')}></div>
                                            </div>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="1">
                                            <Card.Body>
                                                <div className="form-group row noma">
                                                    <label className="col-sm-6 col-form-label nopa">Name</label>
                                                    <div className="col-sm-6 nopa">
                                                        <p className="form-control-plaintext text-right">{profileState.name}</p>
                                                    </div>
                                                </div>
                                                <div className="form-group row noma">
                                                    <label className="col-sm-6 col-form-label nopa">Surname</label>
                                                    <div className="col-sm-6 nopa">
                                                        <p className="form-control-plaintext text-right">{profileState.surname}</p>
                                                    </div>
                                                </div>

                                                {profileState.cellphoneNumber &&
                                                    <div className="form-group row noma">
                                                        <label className="col-sm-6 col-form-label nopa">Contact no.</label>
                                                        <div className="col-sm-6 nopa">
                                                            <p className="form-control-plaintext text-right">{profileState.cellphoneNumber}</p>
                                                        </div>
                                                    </div>
                                                }

                                                {cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleMake && cover.riskItems[0].vehicleDetails.vehicleMake !== " " &&
                                                    <div className="form-group row noma">
                                                        <label className="col-sm-6 col-form-label nopa">Make & model</label>
                                                        <div className="col-sm-6 nopa">
                                                        <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleMake}</p>
                                                        </div>
                                                    </div>
                                                }

                                                {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.colour !== "" &&
                                                    <div className="form-group row noma">
                                                        <label className="col-sm-6 col-form-label nopa">Colour</label>
                                                        <div className="col-sm-6 nopa">
                                                            {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.colour !== "" &&
                                                                <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.colour}</p>
                                                            }
                                                            {cover.riskItems[0].vehicleDetails === null &&
                                                                <p className="form-control-plaintext text-right">N/A</p>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                               
                                                {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.registrationNumber !== "" &&
                                                    <div className="form-group row noma mb-15px">
                                                    <label className="col-sm-6 col-form-label nopa">Reg no.</label>
                                                    <div className="col-sm-6 nopa">
                                                    <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.registrationNumber}</p>
                                                    </div>
                                                </div>
                                                }
                                                
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Policy Details - Mobile layout*/}
                <div className="d-lg-none d-block policyDetailsCodeRed" id="PolicyDetailsMobile" style={{ display: "none" }}>
                    <div className="pl-3 pr-3">
                        <div id="firstDiv" className="row border-bottom pt-3 pb-3">
                            <div className="col-12">
                                <h2 className="carName mb-0">{cover.riskItems[0].description}</h2>
                                <p className="Personal-safety-assi mt-10px">Personal safety assistance</p>
                                <p className="mb-0">Monthly premium</p>
                                <h3 className="coverAmount mb-3">{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                {coverStartDate.length > 0 &&
                                    <div>
                                        <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                        <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                    </div>
                                }
                            </div>
                            <div className="col-12">
                                {!isInEdit &&
                                    <button className="btn btn-outline-red mb-20px mt-3 mr-1 font-size-16px" onClick={editPolicyInfo} id="EditPolicy">Update policy</button>
                                }
                                {isInEdit &&
                                    <div className="mt-3 mb-3">
                                        <button className="btn btn-outline-red mr-lg-0 mb-2" onClick={cancelEdit} id='CancelPolicyEdit'>Cancel edit</button>
                                        <button className="btn btn-outline-red mt-lg-0 mb-2 mt-2" onClick={saveEdit} id='SavePersonalEdit'>Save changes</button>
                                    </div>
                                }
                            </div>
                        </div>

                        {/*Benefits*/}
                        <div id="BenefitsDiv" className="mt-3 mb-3">
                            <p className="Benefits">Benefits</p>
                            <div className="row">
                                <div className="col-12 mb-2 new-benefits-col">
                                    <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">24/7 assistance</span>
                                </div>
                                <div className="col-12 mb-2 new-benefits-col">
                                    <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">Instant response</span>
                                </div>
                                <div className="col-12 new-benefits-col">
                                    <div className="icon-checkmark-circle"></div> <span className="BenefitsItems">Cover in all major/sub-metros</span>
                                </div>
                            </div>
                        </div>

                        {/*Test code red*/}
                        <div className="row border-top"></div>
                        <div id="TestCodered" className="mt-3 mb-3">
                            <p className="Benefits">Test code red</p>
                            <div className="row py-2">
                                <div className="col-12">
                                    <p>Please take a minute to test code red on your mobile device (phone or tablet) with the King Price app.</p>
                                </div>
                                <div className="col-12">
                                    <a className="btn btn-solid-aqua" id="buttonAquaMobile" href={downloadApp} target="_blank">Download the app</a>
                                </div>
                            </div>
                        </div>

                        {/*Where am I covered*/}
                        <div className="row border-top"></div>
                        <div id="Accessories" className="mt-3">
                            <p className="Benefits">Where am I covered</p>
                            <div className="row py-2">
                                <div className="col-12">
                                    <p>You’re covered in all major metros and sub-metros and many outlying areas. For more info on our response network click on the ‘see available areas’ button:</p>
                                </div>
                                <div className="col-12">
                                    <a className="btn btn-outline-red mb-3 mt-3 mr-1" href={availableAreas} id="areasMobile" target="_blank">See available areas</a>
                                </div>
                            </div>
                        </div>

                        {/*Policy holder details*/}
                        <div className="row border-top"></div>
                        <div id="DetailsDiv" className="mt-4 pb-3 code-red-accordion-holder">
                            <Accordion onSelect={(e) => setAccordionPolicyActiveKey(Number(e))}>
                                <Card className="mb-3">
                                    <Accordion.Toggle as={Card.Header} eventKey="1">
                                        <p className="CardTitle">Policyholder details</p>
                                        <div id="PolicyDetailsAccordion" className={" accordion-arrow-svg" + ((accordionPolicyActiveKey === 1) ? ' isRotatednew' : '')}></div>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body>
                                            <div className="form-group row noma">
                                                <label className="col-6 col-form-label">Name</label>
                                                <div className="col-6">
                                                    <p className="form-control-plaintext text-right">{profileState.name}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row noma">
                                                <label className="col-6 col-form-label">Surname</label>
                                                <div className="col-6">
                                                    <p className="form-control-plaintext text-right">{profileState.surname}</p>
                                                </div>
                                            </div>
                                            <div className="form-group row noma">
                                                <label className="col-6 col-form-label">Contact no.</label>
                                                <div className="col-6">
                                                    <p className="form-control-plaintext text-right">{profileState.cellphoneNumber}</p>
                                                </div>
                                            </div>

                                            {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.vehicleMake && cover.riskItems[0].vehicleDetails.vehicleMake !==" " &&
                                                <div className="form-group row noma">
                                                    <label className="col-6 col-form-label">Make & model</label>
                                                    <div className="col-6">
                                                        {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.vehicleMake &&
                                                            <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.vehicleMake}</p>
                                                        }
                                                        {cover.riskItems[0].vehicleDetails === "" || cover.riskItems[0].vehicleDetails === null &&
                                                            <p className="form-control-plaintext text-right">N/A</p>
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.colour &&
                                                <div className="form-group row noma">
                                                    <label className="col-6 col-form-label">Colour</label>
                                                    <div className="col-6">
                                                        {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.colour &&
                                                            <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.colour}</p>
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.registrationNumber &&
                                                <div className="form-group row noma">
                                                    <label className="col-6 col-form-label">Reg no.</label>
                                                    <div className="col-6">
                                                        {cover.riskItems[0].vehicleDetails !== null && cover.riskItems[0].vehicleDetails.registrationNumber &&
                                                            <p className="form-control-plaintext text-right">{cover.riskItems[0].vehicleDetails && cover.riskItems[0].vehicleDetails.registrationNumber}</p>
                                                        }
                                                        {cover.riskItems[0].vehicleDetails === "" || cover.riskItems[0].vehicleDetails === null &&
                                                            <p className="form-control-plaintext text-right">N/A</p>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>

            {/*Dynamic FAQ Accordian*/}
            <div className="col-12 col-lg nopa ml-5px mobile-ml-0px">
                <Card className="policyDetailsCodeRed code-red-holder ">
                    <div className="font-size-22px font-weight-bold mt-20px mobile-mt-0px mb-20px">FAQs</div>
                    <div className="new-ssp-code-red-faq-block code-red-accordion-holder">
                        <Accordion onSelect={(e) => setAccordionFAQActiveKey(Number(e))}>
                            {faq}
                        </Accordion>
                    </div>
                </Card>
            </div>
        </>
    )
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

export default connect(mapStateToProps)(PolicyDetailsCodered);
